import { render, staticRenderFns } from "./ProcessDetails.vue?vue&type=template&id=142a305b&scoped=true&"
import script from "./ProcessDetails.vue?vue&type=script&lang=js&"
export * from "./ProcessDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142a305b",
  null
  
)

export default component.exports